function rebaseFrom(rebaseOption) {
  return undefined === rebaseOption ? true : !!rebaseOption;
}

module.exports = rebaseFrom;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/options/rebase.js
// module id = 2314
// module chunks = 0